import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateBirthdays = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{opacity:.1;}.d{fill:#fafcff;}.e{fill:#9ec5ff;}.f{fill:#b5c5ea;}.g{fill:#dcebfe;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "d",
				cx: 237.88,
				cy: 250.99,
				r: 237.99
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [/* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("rect", {
					className: "g",
					x: 142.49,
					y: 131.79,
					width: 334.66,
					height: 281.55,
					rx: 5,
					ry: 5
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "f",
					x: 119.54,
					y: 131.79,
					width: 380.56,
					height: 76.47,
					rx: 5,
					ry: 5
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 284.64,
					y: 128.88,
					width: 50.36,
					height: 284.45
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "e",
					d: "M430.75,117.73l-28.53-63.25c-.59-1.31-2.26-1.72-3.4-.83l-89.48,70.41L220.81,54.39c-1.13-.89-2.8-.48-3.4,.83l-28.53,63.25c-.59,1.31,.21,2.84,1.62,3.1l85.31,15.59-55.42,41.31c-1.1,.82-1.2,2.43-.21,3.38l23.03,22.13c.99,.95,2.59,.79,3.37-.35l39.14-57.15c.42,.26,.95,.39,1.54,.28l20.52-3.75,24.58,4.49c.76,.14,1.4-.11,1.87-.54l38.81,56.68c.78,1.13,2.38,1.3,3.37,.35l23.03-22.13c.99-.95,.89-2.56-.21-3.38l-56.22-41.9,86.11-15.74c1.42-.26,2.22-1.78,1.62-3.1Z"
				})
			] }), /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("rect", {
						className: "c",
						x: 99.08,
						y: 272.56,
						width: 124.95,
						height: 98.6,
						rx: 20,
						ry: 20
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "g",
						x: 92.16,
						y: 265.63,
						width: 124.95,
						height: 98.6,
						rx: 20,
						ry: 20
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M112.16,265.63h84.95c11.04,0,20,8.96,20,20v4.51H92.16v-4.51c0-11.04,8.96-20,20-20Z"
					})
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("circle", {
						className: "e",
						cx: 114.61,
						cy: 310.23,
						r: 7
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "e",
						cx: 114.61,
						cy: 338.54,
						r: 7
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "e",
						cx: 154.55,
						cy: 310.23,
						r: 7
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "e",
						cx: 154.55,
						cy: 338.54,
						r: 7
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "e",
						cx: 194.49,
						cy: 310.23,
						r: 7
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "e",
						cx: 194.49,
						cy: 338.54,
						r: 7
					})
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
					className: "f",
					x: 124.16,
					y: 255.59,
					width: 10,
					height: 20.08,
					rx: 5,
					ry: 5
				}), /* @__PURE__ */ _jsx("rect", {
					className: "f",
					x: 175.11,
					y: 255.59,
					width: 10,
					height: 20.08,
					rx: 5,
					ry: 5
				})] })
			] })]
		})
	]
});
export default SvgEmptyStateBirthdays;
